export const HomePageSearch = {
    init: () => {
        // get all search buttons
        var searchButton = document.querySelectorAll(".search-button");
        if (searchButton.length > 0) {
            for (var i = 0; i < searchButton.length; i++) {
                searchButton[i].addEventListener("click", function () {
                    var searchForm = document.forms["search-box"];
                    if (searchForm) {
                        // check if searchButton has class desktop
                        if (this.classList.contains("desktop")) {
                            // find the input with name locations inside div having class search-box--mobile
                            var city = searchForm.elements["locations-desktop"].options[searchForm.elements["locations-desktop"].selectedIndex].value;
                            var bedrooms = searchForm.elements["bedrooms-desktop"].value;
                        } else {
                            var city = searchForm.elements["locations-mobile"].options[searchForm.elements["locations-mobile"].selectedIndex].value;
                            var bedrooms = searchForm.elements["bedrooms-mobile"].value;
                        }

                        var locations = searchForm.elements["locations-desktop"];
                        var locationsOptions = locations.options;
                        var locationsOptionsLength = locationsOptions.length;
                        var locationsOptionsDataCityId = [];
                        for (var i = 0; i < locationsOptionsLength; i++) {
                            // check if option has attribute data-city-id
                            if (locationsOptions[i].hasAttribute("data-city-id")) {
                                // push the value of data-city-id in locationsOptionsDataCityId array
                                locationsOptionsDataCityId.push(
                                    locationsOptions[i].getAttribute("data-city-id")
                                );
                            }
                        }
                        // if city is equal null then comma separate all values of locationsOptionsDataCityId array and assign it to city
                        if (city == "null") {
                            city = locationsOptionsDataCityId.join(",");
                        }
                        // create a search query
                        var searchQuery =
                                "City=" +
                                city +
                                "&AvailableOnly=0&BedroomsMin="+bedrooms+"&BedroomsMax=5";
                        // console.log(searchQuery);
                        // redirect to search page (/find-your-home/?) with searchQuery
                        window.location.href = "/find-your-home/?" + searchQuery;
                    }
                });
            }
        }
    },
};
